import React, { useEffect } from 'react';
import {
    changeDepartment1All,
    changeTitle1All,
    changeAddressAll,
    changeAddress2All,
    changePhoneAll,
    changeFaxAll,
    changePrescriptionPadDoctorsAll,
} from './../CanvasActions';
import TextField from './../Form/TextField';
import SelectField from './../Form/SelectField';

const FormP18T2 = React.memo((props) => {
    useEffect(() => {
        changeDepartment1All(props.department1);
    }, [props.department1]);

    useEffect(() => {
        changeTitle1All(props.title1);
    }, [props.title1]);

    useEffect(() => {
        changeAddressAll(props.address);
    }, [props.address]);

    useEffect(() => {
        changeAddress2All(props.address2);
    }, [props.address2]);

    useEffect(() => {
        changePhoneAll(props.phone);
    }, [props.phone]);

    useEffect(() => {
        changeFaxAll(props.fax);
    }, [props.fax]);

    useEffect(() => {
        changePrescriptionPadDoctorsAll(props.prescriptionPadDoctors);
    }, [props.prescriptionPadDoctors]);

    const changeDoctorField = (index, field, event) => {
        props.setPrescriptionPadPersonField(index, field, event.target.value);
    };

    const renderDoctors = () => {
        return props.prescriptionPadDoctors.map((doctor, index) => {
            return (
                <div className="doctor-line">
                    <div className="name-field">
                        <div className="label">Name <span className="required">*</span>:</div>
                        <input
                            type="text"
                            placeholder="Example: Jane A. Doe, MD"
                            value={doctor.name}
                            onChange={changeDoctorField.bind(this, index, 'name')}
                        />
                    </div>
                    <div className="lic-field">
                        <div className="label">Lic#:</div>
                        <input
                            type="text"
                            placeholder="C123456"
                            value={doctor.lic}
                            onChange={changeDoctorField.bind(this, index, 'lic')}
                        />
                    </div>
                    <div className="dea-field">
                        <div className="label">DEA#:</div>
                        <input
                            type="text"
                            placeholder="AH12345678"
                            value={doctor.dea}
                            onChange={changeDoctorField.bind(this, index, 'dea')}
                        />
                    </div>
                    <div className="delete-icon">
                        <i className="fas fa-trash" onClick={props.removePrescriptionPadPersonByIndex.bind(this, index)}></i>
                    </div>
                </div>
            );
        });
    };

    let addDoctorButton = <div className="add-person-button" onClick={props.addPrescriptionPadPerson}><i class="fas fa-plus" /> Add Doctor</div>;
    if (props.prescriptionPadDoctors.length >= 12) {
        addDoctorButton = <div></div>;
    }

    return (
        <form action="" className="form-container-p18t2">
            <hr />
            <TextField
                label="Name of department"
                value={props.department1}
                setFunction={props.setDepartment1}
                placeholder="Name of department"
            />
            <TextField
                required
                label="Name of location"
                value={props.title1}
                setFunction={props.setTitle1}
                placeholder="Name of location"
            />
            <TextField
                required
                label="Address"
                value={props.address}
                setFunction={props.setAddress}
                placeholder="Example: 12345 Street, Suite 2022"
            />
            <TextField
                required
                label="City, State, Zip"
                value={props.address2}
                setFunction={props.setAddress2}
                placeholder="Example: Houston, TX 77000"
            />
            <TextField
                required
                isPhone
                phoneFormat={3}
                label="Phone"
                value={props.phone}
                setFunction={props.setPhone}
                placeholder="Main phone"
            />
            <TextField
                isPhone
                phoneFormat={3}
                label="Fax"
                value={props.fax}
                setFunction={props.setFax}
                placeholder="Fax (optional)"
            />
            <hr />
            <h2>Prescribing providers <span>(You can list up to 12 names)</span></h2>
            <div className="doctors-list">
                {renderDoctors()}
            </div>
            <div className="buttons-container">
                {addDoctorButton}
            </div>
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '1', label: '1 Pad' },
                    { value: '5', label: '5 Pads' },
                    { value: '10', label: '10 Pads' },
                    { value: '25', label: '25 Pads' },
                    { value: '50', label: '50 Pads' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> Emergency/Downtime Prescription Pad</div>
                <div className="description-list">
                    <span className="label">Description:</span>
                    <div className="mt-1 mb-2">
                        Security prescription pads must only be ordered as part of our emergency procedures for Epic downtime.
                        All emergency prescription pads should be stored in a locked cabinet accessed by clinic leadership only.
                    </div>
                    <ul>
                        <li>Flat: 4.25" x 5.5"</li>
                        <li>Stock: RX Blue Stock</li>
                        <li>Printed: Black ink security stock no bleeds</li>
                        <li>Bindery: 50 (sheets per pad)</li>
                    </ul>
                </div>
            </div>
        </form>
    );
});

export default FormP18T2;
